import { DRAWER_TYPES } from 'appConstants';
import { Action } from 'redux';

/* Types */

interface DrawerAction extends Action {
  readonly drawerType?: string;
}

enum Actions {
  SET_DRAWER_TYPE = 'SET_DRAWER_TYPE',
}

export interface Drawer {
  readonly drawerType?: string | undefined;
}

const initialState = {
  drawerType: DRAWER_TYPES.NONE,
} as Drawer;

const setDrawerType = (drawerType: string): DrawerAction => ({
  type: Actions.SET_DRAWER_TYPE,
  drawerType,
});

/* Reducer */

const drawerReducer = (state = initialState, action: DrawerAction) => {
  switch (action.type) {
    /*
     * Add drawer type to store for only keeping the correct drawer open
     */
    case Actions.SET_DRAWER_TYPE:
      return {
        ...state,
        drawerType: action.drawerType,
      };
    default:
      return state;
  }
};

export { drawerReducer, setDrawerType };
